module.exports = __webpack_public_path__ + "img/6.e8e29ae1.png";